import React from "react";

import { Col, Container, Row } from "reactstrap";

import Main from "../components/Main";
import EnvHeader from "../components/EnvHeader";
import { version } from "../../package.json";

const Auth = ({ children }) => (
  <React.Fragment>
    <EnvHeader />

    <Main className="d-flex w-100 justify-content-center">
      <Container className="d-flex flex-column">
        <Row className="h-100">
          <Col sm="10" md="8" lg="6" className="mx-auto d-table h-100">
            <div className="d-table-cell align-middle">{children}</div>
          </Col>
        </Row>
      </Container>
    </Main>

    <Container fluid style={{ position: "fixed", bottom: 0 }} className="w-100">
      <Row className="m-0 p-0">
        <Col className="text-center text-muted">
          <small>v{version}</small>
        </Col>
      </Row>
    </Container>
  </React.Fragment>
);

export default Auth;
